import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger"]

  connect() {
    // Hide submenu if not active
    this.triggerTargets.forEach(element => {
      const target = document.getElementById(element.getAttribute("aria-controls"))

      if (element.getAttribute("aria-expanded")){
        return false
      }

      if (target) {
        element.setAttribute("aria-expanded", "false")
        target.setAttribute("aria-hidden", "true")
      }
    })
  }

  toggle(e) {
    const trigger = e.currentTarget
    const target = document.getElementById(trigger.getAttribute("aria-controls"))
    const state = trigger.getAttribute("aria-expanded") !== "false"

    trigger.setAttribute("aria-expanded", !state)
    target.setAttribute("aria-hidden", state)
  }

  selectToggle(e) {
    Turbo.visit(e.currentTarget.value)
  }
}
